import { motion } from 'framer-motion';
import React, { useEffect } from 'react';
import { FaMapMarkedAlt } from 'react-icons/fa';
import QdtComponent from '../../components/QdtComponent';
import { useApp } from '../../context/AppContext';
import { fadeIn } from '../../util/animation';


export default function Geography() {

	const {goToTop, clearAllSelections} = useApp()
	
	useEffect(() => {
    goToTop()
  }, [goToTop])

  return (
		<motion.div variants={fadeIn} initial="hidden" animate="show">
		<section className="section-space golf-field-bg-img bg-img-property">
			<div className="container">
				<div className="row rowsafari">
					<div className="col-lg-12">
						<div className="row">
							<FaMapMarkedAlt color={'white'} size={54}/>
							<h3 className="text-white text-center pt-2">Geography</h3>
						</div>
					</div>
				</div>
			</div>
		</section>
    <section className="mt-3 mb-3">
			<div className="container">
				<div className="row mb-3">
					<div className="col "><h6 className="section-grp-margin-bottom text-success fs-3">Geography</h6></div>
					<div className="col text-light text-end">
						<button onClick={() => clearAllSelections()} className="btn btn-warning text-success">Clear Selections</button>
					</div>
				</div>
				<div className="row rowsafari">
					<div className="col-lg-6 col-sm-12 col-md-12 res-desk-mar-bot">
						<div className="border border-success rounded">
							<QdtComponent
								type="QdtViz"
								props={{
									id: 'azMcjFP',
									height: '550px'
								}}
								/>
						</div>
					</div>
					<div className="col-lg-6 col-sm-12 col-md-12 res-desk-mar-bot">
						<div className="border border-success rounded">
							<QdtComponent
								type="QdtViz"
								props={{
									id: 'qBbmB',
									height: '550px'
								}}
								/>
						</div>
					</div>
				</div>
			</div>
		</section>
		</motion.div>
  )
}